import React, { useContext } from 'react';
import { AuthContext } from '../../auth/AuthContext';
import { useNavigate } from 'react-router-dom';
import { Button, Box, Typography } from '@mui/material';
import { styled } from '@mui/system';
import BackgroundContainer from '../../components/BackgroundContainer';
import BaseHeader from '../../components/BaseHeader';
import BaseButton from '../../components/BaseButton';
import BaseFormContainer from '../../components/BaseFormContainer';

const Subtitle = styled(Typography)({
  fontFamily: 'Playfair Display, serif',
  fontSize: '1.5rem',
  color: '#ffbfe1',
  textAlign: 'center',
  textShadow: '0px 2px 6px rgba(0, 0, 0, 0.5)',
  lineHeight: '1.4',
  marginBottom: "20px",
});

const SuccessPaymentPage = () => {
  const { auth } = useContext(AuthContext);
  const navigate = useNavigate();
  return (
    <BackgroundContainer>
      <BaseFormContainer sx={{
        width: '100%',
        padding: { xs: 2, sm: 3 },
        boxSizing: 'border-box',
        marginBottom: '20px',
        '@media (max-height: 780px)': {
          height: '100%'
        },
      }} >
        <BaseHeader sx={{
          fontSize: '4rem', // 🎯 Full size title
          '@media (max-width: 380px)': {
            fontSize: '3.8rem', // 🧠 Gentle scale-down on ultra-small screens
          },
          '@media (max-width: 360px)': {
            fontSize: '3.4rem', // 🧠 Gentle scale-down on ultra-small screens
          },
          '@media (max-width: 320px)': {
            fontSize: '3rem', // 🔒 Last-resort fallback for smallest devices
            lineHeight: '1.1',
          },
          textAlign: 'center', // (optional) center if you want
        }} >
          Payment Successful!
        </BaseHeader>
        <Subtitle
          style={{
            color: 'rgba(237, 218, 241, 0.7)',
            marginBottom: '20px',
            textAlign: 'center',
            fontSize: '1.2rem',
            '@media (max-width: 400px)': {
              fontSize: '1.1rem',
            },
            '@media (max-width: 360px)': {
              fontSize: '1rem',
            },
            '@media (max-width: 320px)': {
              fontSize: '0.95rem',
            },
          }} >
          Thank you for your purchase. Enjoy the new features!
        </Subtitle>

        <BaseButton onClick={() => navigate('/')}>
          Back
        </BaseButton>
      </BaseFormContainer>
    </BackgroundContainer>

  );
};

export default SuccessPaymentPage;